exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-5be65f4e]{font-size:1.6em}.booking-information[data-v-5be65f4e]{padding:20px 30px 30px;padding:20px 3px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5be65f4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/additional-services/Home.vue
// module id = 503
// module chunks = 0